import React from 'react'
import { FaArrowUp } from "react-icons/fa";

function GoToTop({containerRef}) {

    const styles = {
        container: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            backgroundColor: 'rgb(255, 210, 48)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            zIndex: 9999,
        },
    };

    return (
        <div style={styles.container} onClick={() => containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' })}>
            <FaArrowUp style={{ color: 'white' }} />
        </div>
    )
}

export default GoToTop;